module.exports = __webpack_public_path__ + "static/media/login-outline.a72372f8.svg";